import { unref as _unref, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-no-categories": "",
  class: "text-sm text-gray-500"
}

import { computed } from 'vue'

import SelectInput from '@/components/neue/SelectInput.vue'
import AmountField from '@/components/neue/wizard/AmountField.vue'
import NumberStepper from '@/components/neue/wizard/NumberStepper.vue'
import PillRadioGroup from '@/components/neue/wizard/PillRadioGroup.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { BILLING_INTERVALS, expiryOptions, GRANT_DAYS, sectionCopy } from '@/config/membershipTierWizardSteps'


export default {
  __name: 'StepMealPlan',
  props: {
  categories: { type: Array, default: () => [] },
  categoriesKnown: { type: Boolean, default: true }
},
  setup(__props) {

const props = __props

const wizard = injectWizard()
const plan = computed(() => wizard.data.mealPlan)
const expiries = computed(() => expiryOptions(wizard.data))
const categoryOptions = computed(() => props.categories.map(category => ({ name: category.name, value: category.id })))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('mealPlanPrice', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createVNode(AmountField, {
          modelValue: plan.value.priceCents,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((plan.value.priceCents) = $event)),
          kind: "money",
          name: "Price"
        }, null, 8, ["modelValue"]),
        _createVNode(PillRadioGroup, {
          modelValue: plan.value.billingInterval,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((plan.value.billingInterval) = $event)),
          options: _unref(BILLING_INTERVALS),
          label: "Billed"
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('mealPlanMeals', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createVNode(NumberStepper, {
          modelValue: plan.value.itemCount,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((plan.value.itemCount) = $event)),
          name: "Meals included",
          min: 1
        }, null, 8, ["modelValue"]),
        _createVNode(SelectInput, {
          "model-value": plan.value.categoryId,
          name: "Meal category",
          placeholder: "Pick a category",
          options: categoryOptions.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (plan.value.categoryId = $event))
        }, null, 8, ["model-value", "options"]),
        (__props.categoriesKnown && !__props.categories.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Add a category to a store first. Customers pick their included meals from that category. "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _normalizeProps(_guardReactiveProps(_unref(sectionCopy)('mealPlanGrants', _unref(wizard).data))), {
      default: _withCtx(() => [
        _createVNode(PillRadioGroup, {
          modelValue: plan.value.grantInterval,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((plan.value.grantInterval) = $event)),
          options: _unref(BILLING_INTERVALS),
          label: "Meals granted"
        }, null, 8, ["modelValue", "options"]),
        (plan.value.grantInterval === 'monthly')
          ? (_openBlock(), _createBlock(AmountField, {
              key: 0,
              modelValue: plan.value.grantDate,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((plan.value.grantDate) = $event)),
              kind: "integer",
              name: "Day of the month"
            }, null, 8, ["modelValue"]))
          : (_openBlock(), _createBlock(SelectInput, {
              key: 1,
              "model-value": plan.value.grantDay,
              name: "Grant day",
              options: _unref(GRANT_DAYS),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (plan.value.grantDay = $event))
            }, null, 8, ["model-value", "options"]))
      ]),
      _: 1
    }, 16),
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('mealPlanExpiry', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, {
          label: _unref(sectionCopy)('mealPlanExpiry', _unref(wizard).data).title
        }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expiries.value, (option) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: option.value,
                name: groupName,
                compact: "",
                title: option.title,
                selected: plan.value.expiry === option.value,
                onSelect: $event => (plan.value.expiry = option.value)
              }, null, 8, ["name", "title", "selected", "onSelect"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 16)
  ], 64))
}
}

}